import React from 'react'
import {StaticText} from '../../StaticText/StaticText'

interface ICategoriaNomeProps {
    texto?: string
}

const CategoriaNome: React.FC<ICategoriaNomeProps> = ({
    texto
}) => {

    if (!texto) return null

    return (
        <StaticText textSize='0.7em' textColor='var(--color-gray-2)'>
            {texto}
        </StaticText>
    )
}
  
export default CategoriaNome